// extracted by mini-css-extract-plugin
module.exports = {"localeSwitcher":"locale-switcher_localeSwitcher__cjxs3"};